import { Boolean, Literal, Number, Record, Static, String, Undefined } from 'runtypes';

export const ArchivButtonRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	archived: Literal(false).Or(Literal(true)).Or(Undefined),
	changeable: Boolean,
	processId: String,
	render: Boolean,
});

export type ArchivButton = Static<typeof ArchivButtonRunType>;
